export function footerFunc() {
  let jsFServiceBtn;
  jsFServiceBtn = $('#jsFServiceBtn');

  jsFServiceBtn.on('click', function () {
    $(this).toggleClass('open').next().stop().slideToggle();
  });
}